// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"2c64d1be","307":"8de66dd4","312":"ac02f0aa"}[chunkId] + ".js";
};